import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '@node-space/storybook-components/dist/Icon'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'

interface RefundConfirmationProps {
  handleClose: () => void
}

export const RefundComplete = ({ handleClose }: RefundConfirmationProps) => {
  const { t } = useTranslation()

  const headline = t('approvals.sentForApprovalDisclaimer')

  const description = t('wallets.fiatSend.requiresApprovalDescription')

  return (
    <StatusCard
      testid="complete-success"
      headline={headline}
      customIcon={<Icon name="HourglassIcon" size="lg" />}
      description={description}
      borderless
      status="success"
      cardButton={{
        onClick: handleClose,
        name: t('wallets.fiatSend.done'),
      }}
    />
  )
}
